import React, { useState, forwardRef, useEffect,useRef, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import logo from '../jsx/components/Reports/food.jpeg';

const TechnicianSalaries = forwardRef((props, ref) => {
  const [allSalaries, setAllSalaries] = useState([]);
  const [specificSalaries, setSpecificSalaries] = useState([]);
  const [technicianId, setTechnicianId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [inviteModal, setInviteModal] = useState(false);
  const componentRef = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Userdata",
    onAfterPrint: () => setInviteModal(false)
  });
  const [technicians, setTechnicians] = useState([]); // State to hold technician list
  const fetchTechnicians = async () => {
    try {
        const response = await axios.get(`https://subk.education.com.ly/back/api/technicians`);
        setTechnicians(response.data); // Assuming response data is a list of technicians
    } catch (error) {
        console.error('Error fetching technicians:', error);
    }
};
    const [company, setcompany] = useState([]);

 useEffect(() => {
      const companydata = localStorage.getItem('companies');
      if (companydata) {
        const parsedData = JSON.parse(companydata);
        const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
        setcompany(singleCompany); // Set state to a single object
      }
    }, []);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      fetchTechnicians();
      fetchAllSalaries();

      setInviteModal(true);
    }
  }));
  const fetchAllSalaries = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://subk.education.com.ly/back/api/gettechnicianSalaries');
      setAllSalaries(response.data);
    } catch (err) {
      setError('Error fetching all technician salaries');
    } finally {
      setLoading(false);
    }
  };

    const [technicianID, setTechnicianID] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // Filtered data based on TechnicianID and Date range
    const filteredData = allSalaries.filter((item) => {
        const repairDate = new Date(item.RepairDate);
        const isTechnicianMatch = technicianID ? item.TechnicianID === parseInt(technicianID) : true;
        const isDateInRange =
            (startDate ? repairDate >= new Date(startDate) : true) &&
            (endDate ? repairDate <= new Date(endDate) : true);

        return isTechnicianMatch && isDateInRange;
    });

    return (
      <Modal className="modal fade" id="exampleModal1" size="xl" show={inviteModal} centered>
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="exampleModalLabel1">تقرير الفنيين</h1>
          <button
            type="button"
            className="btn-close"
            style={{ marginLeft: 0 }}
            onClick={() => setInviteModal(false)}
          ></button>
        </div>
        <div className="modal-body pt-2">
            
            {/* Filters */}
            <div className="row" style={{ marginBottom: '20px' }}>
  {/* Technician Input */}
  <div className="col-3 d-flex align-items-center m-3">
    <label className="form-label ms-2">الفني:</label>
    <select className="default-select form-control  " name="TechnicianID" 
value={technicianID}
onChange={(e) => setTechnicianID(e.target.value)} >
                           <option data-display="Select" ></option>
                            {technicians.map(tech => (
                                                                    <option key={tech.TechnicianID} value={tech.TechnicianID}>
                                                                        {tech.FirstName}  
                                                                    </option>
                                                                ))}
                              
                         </select>
    
  </div>

  {/* Start Date Input */}
  <div className="col-3 d-flex align-items-center m-3">
    <label className="form-label ms-2">من:</label>
    <input
      className="form-control"
      type="date"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
    />
  </div>

  {/* End Date Input */}
  <div className="col-3 d-flex align-items-center m-3">
    <label className="form-label ms-2">إلى:</label>
    <input
      className="form-control"
      type="date"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
    />
  </div>
</div>

            {/* Table 
            <table  style={{ maxHeight: '400px', overflowY: 'auto' }} className="table dataTable display table-hover scrol">*/}
            <div  ref={componentRef}  dir='rtl'style={{  marginLeft :'20px'  , marginRight:'20px'}}>
            <div className="row mx-3">
                    <div className="col-xl-12 text-center row">
                    <div  style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      }}>  <div 
    style={{
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
                    <div className="d-flex"><h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold'}}>{company.CompanyName}</h2> </div>
                   <div className="d-flex"> <h2 style={{fontFamily: 'SC_AMEEN',color:'#003b53',fontWeight:'lighter'}}>{company.Description}</h2>  </div>
                   <div className="d-flex">                  
                   <h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}> تقرير بأعمال الموظفين</h2>
 </div> </div>

 <img src={`https://subk.education.com.ly/back${company.ImageName}`} alt="Logo" style={{ height: "100px", width: "150px",  marginTop: '-10px',   marginLeft:'30px' }} />                     </div>
                  </div> 
                  </div> 

                  <div className="table-responsive" style={{height: "200px"}}>
                    <table className="table table-bordered" style={{  marginLeft :'20px'  , marginRight:'20px'}}>
             <thead style={{ position: "sticky", top: 0,  zIndex: 1, backgroundColor:"#8869e1"}}>                      

                    <tr>
                         <th>اسم الفني</th>
                        <th>اسم الخدمة</th>
                        <th>تاريخ الصيانة</th>
                        <th>حالة الدفع</th>
                        <th>تكلفة الخدمة</th>
                        <th>حصة الفني</th>
                        <th>بييانات السيارة</th>

                    </tr>
                </thead>
                <tbody>
                {filteredData && filteredData.length > 0 ? (
  filteredData.map((item, index) => (
    <tr key={index}>
      <td>{item.TechnicianName || '-'}</td>
      <td>{item.ServiceName || '-'}</td>
      <td>{item.RepairDate || '-'}</td>
      <td>{item.PayStatus || '-'}</td>
      <td>{item.ServiceStandardPrice || '-'}</td>
      <td>{item.SalaryAmount || '-'}</td>
      <td >
        {item.LicensePlate ? `${item.LicensePlate}, ` : ''}
        {item.EngineNumber ? `${item.EngineNumber}, ` : ''}
        {item.MakeName ? `${item.MakeName}, ` : ''}
        {item.ModelName || ''}
      </td>
    </tr>
  ))
) : (
  <tr>
    <td colSpan="10" style={{ color : 'blue'}}  > <i class="fa-solid fa-circle-info"></i>{' '}لا توجد بيانات  </td>
  </tr>
)}

                </tbody>
            </table></div>
        </div></div></div>
        
        <div className="modal-footer">
            <button  className="btn btn-primary m-2" onClick={generatePDF}>طباعه </button>
 
          </div>
        </Modal>
     );
    });
    
    export default TechnicianSalaries;